module.exports = __webpack_public_path__ + "static/img/OMDP6.91753fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/OMDP6.png
// module id = 70lh
// module chunks = 1